"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[796],{

/***/ 9796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ApolloClientProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(3768);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(522);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
;// CONCATENATED MODULE: ./src/apollo-client/isomorphic-apollo-client.ts

function isomorphicApolloClient(createApolloClient) {
    var apolloClient;
    return function() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var isServer = "object" === "undefined";
        console.log("isomorphicApolloClient", {
            isServer: isServer
        });
        var _apolloClient = apolloClient !== null && apolloClient !== void 0 ? apolloClient : createApolloClient({
            isServer: isServer
        });
        // initialState: cached fetch data on server side
        // SSR props -> initialState: apolloClient.cache.extract()
        if (initialState) {
            var cachedClientState = _apolloClient.cache.extract() // cached fetch data on client side
            ;
            // 단순히 전개 연산자로 merge 할 경우 같은 타입은 그저 initialState 값으로 덮어씌우는 형태여서 client cached data 삭제됨
            var store = Object.keys(initialState).reduce(function(store, key) {
                store[key] = store[key] ? (0,_object_spread/* default */.Z)({}, store[key], initialState[key]) : initialState[key];
                return store;
            }, (0,_object_spread/* default */.Z)({}, cachedClientState));
            _apolloClient.cache.restore(store);
        }
        // always using fresh data when server side
        if (isServer) return _apolloClient;
        apolloClient = apolloClient !== null && apolloClient !== void 0 ? apolloClient : _apolloClient;
        return apolloClient;
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(3440);
;// CONCATENATED MODULE: ./src/utils/apollo-client/type-policies/merge-for-pagination.ts
function mergeForPagination(param) {
    var existing = param.existing, incoming = param.incoming, page = param.page, limit = param.limit;
    var merged = existing ? incoming.length < limit // 네트워크 통해서 가져온 데이터가 이전과 달라진 경우 대응(ex: My뉴스에서 포폴을 모두 제거하거나 스위치 오프한 경우 다시 반영)
     ? existing.slice(0, page * limit + incoming.length) : existing.slice(0) : [];
    for(var i = 0; i < incoming.length; ++i){
        merged[page * limit + i] = incoming[i];
    }
    return merged;
};

;// CONCATENATED MODULE: ./src/utils/apollo-client/type-policies/merge-with-pagination.ts

function mergeWithPagination(existing, incoming, param) {
    var args = param.args;
    var ref;
    var page = (ref = args === null || args === void 0 ? void 0 : args.page) !== null && ref !== void 0 ? ref : 0;
    var ref1, ref2;
    var limit = (ref2 = (ref1 = args === null || args === void 0 ? void 0 : args.limit) !== null && ref1 !== void 0 ? ref1 : existing === null || existing === void 0 ? void 0 : existing.length) !== null && ref2 !== void 0 ? ref2 : 0;
    return mergeForPagination({
        existing: existing,
        incoming: incoming,
        page: page,
        limit: limit
    });
};

;// CONCATENATED MODULE: ./src/utils/apollo-client/type-policies/read-with-pagination.ts
function readWithPagination(existing, param) {
    var args = param.args;
    var ref;
    var page = (ref = args === null || args === void 0 ? void 0 : args.page) !== null && ref !== void 0 ? ref : 0;
    var ref1, ref2;
    var limit = (ref2 = (ref1 = args === null || args === void 0 ? void 0 : args.limit) !== null && ref1 !== void 0 ? ref1 : existing === null || existing === void 0 ? void 0 : existing.length) !== null && ref2 !== void 0 ? ref2 : 0;
    return existing && existing.slice(0, (page + 1) * limit);
};

;// CONCATENATED MODULE: ./src/apollo-client/api-server-possible-types.ts
var result = {
    "possibleTypes": {
        "AdContentDetail": [
            "AdAboveChart",
            "AdAppEnding",
            "AdAppOpening",
            "AdBottomFloating",
            "AdCommunityFeedArticle",
            "AdContentDefault",
            "AdForegroundPopup",
            "AdInappNoti"
        ],
        "ArticleCommentContent": [
            "ArticleContentText"
        ],
        "ArticleContent": [
            "ArticleContentAsset",
            "ArticleContentBackTestingProject",
            "ArticleContentImage",
            "ArticleContentOgTag",
            "ArticleContentPortfolio",
            "ArticleContentText"
        ],
        "ArticleContentSubTextComponent": [
            "ArticleContentTextSubTextComponentCrypto",
            "ArticleContentTextSubTextComponentStock",
            "ArticleContentTextSubTextComponentText",
            "ArticleContentTextSubTextComponentUser"
        ],
        "ArticleTag": [
            "ArticlePortfolioTopic",
            "ArticleStockTag"
        ],
        "BackTestingAsset": [
            "BackTestingCrypto",
            "BackTestingStock"
        ],
        "BackTestingCase": [
            "BackTestingCrypto",
            "BackTestingPortfolio",
            "BackTestingStock"
        ],
        "FollowItem": [
            "FollowCompany",
            "FollowCryptoCurrency",
            "FollowFeedTopic",
            "FollowUser"
        ],
        "InvestingDiaryLog": [
            "InvestingDiaryDepositWithdrawalLog",
            "InvestingDiaryExchangeCurrencyLog",
            "InvestingDiaryMemoLog",
            "InvestingDiaryTradeLog"
        ]
    }
};
/* harmony default export */ var api_server_possible_types = (result);

;// CONCATENATED MODULE: ./src/apollo-client/api-server-apollo-client-cache.ts







function apiServerApolloClientCache() {
    return new inMemoryCache/* InMemoryCache */.h({
        // UNION 타입의 관계를 아폴로 클라이언트가 이해할 수 있도록 설정
        // codegen 으로 가져옴에 유의
        possibleTypes: api_server_possible_types.possibleTypes,
        typePolicies: {
            AssetTagTitle: {
                // id만으로는 counterCurrency 정보가 다른 경우를 식별할 수 없어서 별도의 key를 등록
                // FeedFilteredByTag 쿼리 언어 변경시에 캐시값으로 올때 counterCurrency에 문제가 생기는 현상 대응
                keyFields: [
                    "id",
                    "counterCurrency",
                    [
                        "symbol"
                    ]
                ]
            },
            CryptoExchange: {
                // id가 같아서 language 매개변수에 따라서 name이 다르게 내려오는 현상 대응. API에 language type으로 내려주면 해결 가능
                keyFields: [
                    "id",
                    "name"
                ]
            },
            SearchCompany: {
                keyFields: [
                    "id",
                    "categoryType"
                ]
            },
            // !CAUTION: API2 에서는 한국 주식 이름을 넘겨주지 않아서 임시로 클라이언트에서 처리하는 로직
            CompanyNameLanguage: {
                merge: function merge(existing, incoming) {
                    var ko = !(incoming === null || incoming === void 0 ? void 0 : incoming.ko) && (existing === null || existing === void 0 ? void 0 : existing.ko) ? existing === null || existing === void 0 ? void 0 : existing.ko : incoming === null || incoming === void 0 ? void 0 : incoming.ko;
                    var en = !(incoming === null || incoming === void 0 ? void 0 : incoming.en) && (existing === null || existing === void 0 ? void 0 : existing.en) ? existing === null || existing === void 0 ? void 0 : existing.en : incoming === null || incoming === void 0 ? void 0 : incoming.ko;
                    return !ko && !en ? incoming : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                        ko: ko,
                        en: en
                    });
                }
            },
            Article: {
                fields: {
                    content: {
                        // merge(existing, incoming) {
                        //   return incoming
                        // },
                        // 아티클 수정시 content 구조가 다른 경우 경고(warning 어쩌고) 대응
                        merge: false
                    },
                    portfolioTopics: {
                        // 아티클 수정시 포폴 공유 토픽 다른 토픽으로 수정할 경우 경고(warning 어쩌고) 대응
                        merge: false
                    }
                }
            },
            UserPortfolio: {
                fields: {
                    assets: {
                        merge: false
                    }
                }
            },
            FavoriteItemCategory: {
                fields: {
                    items: {
                        merge: false
                    }
                }
            },
            Query: {
                fields: {
                    timelineFeed: {
                        keyArgs: [
                            "language",
                            "feedTopicId",
                            "portfolioTopicId",
                            "includeInfluencerArticle"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    feedFilteredByTag: {
                        keyArgs: [
                            "assetTagId"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                articles: [],
                                assetTagTitle: {}
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var ref;
                            var cacheArticles = {};
                            var articles = (ref = (0,_to_consumable_array/* default */.Z)(existing.articles).concat((0,_to_consumable_array/* default */.Z)(incoming.articles))) === null || ref === void 0 ? void 0 : ref.reduce(function(articles, article) {
                                if (!cacheArticles[article === null || article === void 0 ? void 0 : article["__ref"]]) {
                                    cacheArticles[article === null || article === void 0 ? void 0 : article["__ref"]] = true;
                                    articles.push(article);
                                }
                                return articles;
                            }, []);
                            return {
                                articles: articles,
                                assetTagTitle: incoming.assetTagTitle
                            };
                        }
                    },
                    userArticles: {
                        keyArgs: [
                            "userId"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    myArticles: {
                        keyArgs: false,
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    myCommentedArticles: {
                        keyArgs: false,
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    myBookmarkedArticles: {
                        keyArgs: false,
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    myFollowings: {
                        keyArgs: [
                            "itemType",
                            "language",
                            "sortOrderType"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                items: [],
                                totalCount: 0
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var _totalCount;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                items: (0,_to_consumable_array/* default */.Z)(existing.items).concat((0,_to_consumable_array/* default */.Z)(incoming.items)),
                                totalCount: (_totalCount = incoming.totalCount) !== null && _totalCount !== void 0 ? _totalCount : existing.totalCount
                            });
                        }
                    },
                    myFollowingFeed: {
                        keyArgs: [
                            "userFollowingId",
                            "language"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    userFollowers: {
                        keyArgs: [
                            "userId",
                            "language"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                items: [],
                                totalCount: 0
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var _totalCount;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                items: (0,_to_consumable_array/* default */.Z)(existing.items).concat((0,_to_consumable_array/* default */.Z)(incoming.items)),
                                totalCount: (_totalCount = incoming.totalCount) !== null && _totalCount !== void 0 ? _totalCount : existing.totalCount
                            });
                        }
                    },
                    userFollowings: {
                        keyArgs: [
                            "itemType",
                            "language",
                            "userId"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                items: [],
                                totalCount: 0
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var _totalCount;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                items: (0,_to_consumable_array/* default */.Z)(existing.items).concat((0,_to_consumable_array/* default */.Z)(incoming.items)),
                                totalCount: (_totalCount = incoming.totalCount) !== null && _totalCount !== void 0 ? _totalCount : existing.totalCount
                            });
                        }
                    },
                    recommendedFollows: {
                        keyArgs: [
                            "itemType",
                            "language"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                items: [],
                                totalCount: 0
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var _totalCount;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                items: (0,_to_consumable_array/* default */.Z)(existing.items).concat((0,_to_consumable_array/* default */.Z)(incoming.items)),
                                totalCount: (_totalCount = incoming.totalCount) !== null && _totalCount !== void 0 ? _totalCount : existing.totalCount
                            });
                        }
                    },
                    searchFollows: {
                        keyArgs: [
                            "itemType",
                            "language",
                            "keyword"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                items: [],
                                totalCount: 0
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            var _totalCount;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                items: (0,_to_consumable_array/* default */.Z)(existing.items).concat((0,_to_consumable_array/* default */.Z)(incoming.items)),
                                totalCount: (_totalCount = incoming.totalCount) !== null && _totalCount !== void 0 ? _totalCount : existing.totalCount
                            });
                        }
                    },
                    searchCommunityArticles: {
                        keyArgs: [
                            "keyword",
                            "language"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                articles: []
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return {
                                articles: (0,_to_consumable_array/* default */.Z)(existing.articles).concat((0,_to_consumable_array/* default */.Z)(incoming.articles))
                            };
                        }
                    },
                    searchCommunityUsers: {
                        keyArgs: [
                            "keyword"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    blockedUsers: {
                        keyArgs: false,
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    searchUsersInArticle: {
                        keyArgs: [
                            "articleId",
                            "keyword"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    userPublicPortfolios: {
                        keyArgs: [
                            "userId"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    myPublicPortfolios: {
                        keyArgs: false,
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                myPublicPortfolios: []
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                myPublicPortfolios: (0,_to_consumable_array/* default */.Z)(existing.myPublicPortfolios).concat((0,_to_consumable_array/* default */.Z)(incoming.myPublicPortfolios))
                            });
                        }
                    },
                    publicFavoriteItems: {
                        keyArgs: [
                            "favoriteItemCategoryId"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                            return (0,_to_consumable_array/* default */.Z)(existing).concat((0,_to_consumable_array/* default */.Z)(incoming));
                        }
                    },
                    investingInsightTags: {
                        read: readWithPagination,
                        merge: mergeWithPagination
                    },
                    investingInsights: {
                        keyArgs: [
                            "language",
                            "tagId"
                        ],
                        read: readWithPagination,
                        merge: mergeWithPagination
                    },
                    lectureContents: {
                        keyArgs: [
                            "lectureContentTagIds"
                        ],
                        merge: mergeWithPagination
                    },
                    userOwnedLectureContents: {
                        keyArgs: [
                            "status"
                        ],
                        merge: mergeWithPagination
                    },
                    userOrderedLectureContents: {
                        keyArgs: false,
                        merge: mergeWithPagination
                    },
                    userWishedLectureContents: {
                        keyArgs: false,
                        merge: mergeWithPagination
                    },
                    lectureContentTags: {
                        keyArgs: false,
                        merge: mergeWithPagination
                    },
                    lectureContentReviews: {
                        keyArgs: [
                            "sortType"
                        ],
                        merge: function merge() {
                            var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                                reviews: []
                            }, incoming = arguments.length > 1 ? arguments[1] : void 0, args = arguments.length > 2 ? arguments[2] : void 0;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incoming), {
                                reviews: mergeWithPagination(existing.reviews, incoming.reviews, args)
                            });
                        }
                    },
                    dividendCalendarByMonth: {
                        keyArgs: [
                            "date",
                            "country",
                            "sortType"
                        ],
                        merge: mergeWithPagination
                    },
                    dividendCalendarByDay: {
                        keyArgs: [
                            "date",
                            "country",
                            "sortType"
                        ],
                        merge: mergeWithPagination
                    },
                    guruInvestItems: {
                        keyArgs: [
                            "guruId",
                            "sortType"
                        ],
                        merge: mergeWithPagination
                    },
                    guruInvestItemsForExternalChannel: {
                        keyArgs: [
                            "guruId",
                            "sortType",
                            "channelName"
                        ],
                        merge: mergeWithPagination
                    },
                    topSellsForExternalChannel: {
                        keyArgs: [
                            "guruId",
                            "channelName"
                        ],
                        merge: mergeWithPagination
                    },
                    topBuysForExternalChannel: {
                        keyArgs: [
                            "guruId",
                            "channelName"
                        ],
                        merge: mergeWithPagination
                    }
                }
            }
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(6909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/from.js
var from = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./node_modules/apollo-upload-client/public/createUploadLink.js
var createUploadLink = __webpack_require__(9776);
var createUploadLink_default = /*#__PURE__*/__webpack_require__.n(createUploadLink);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
// EXTERNAL MODULE: ./src/constants/localstorage.ts
var localstorage = __webpack_require__(6446);
// EXTERNAL MODULE: ./src/utils/browser/localstorage.ts
var browser_localstorage = __webpack_require__(9454);
;// CONCATENATED MODULE: ./src/service/auth.js





/**
 * @deprecated use setAuthToken instead
 */ var saveAuthToken = function(param) {
    var authToken = param.authToken;
    setLocalStorage({
        key: LocalStorageEnum.AuthToken,
        value: authToken
    });
};
/**
 * @deprecated use authTokenStore instead
 */ var getAuthToken = function() {
    if (typeof __webpack_require__.g.localStorage !== "undefined") {
        var authToken = (0,browser_localstorage/* getLocalStorage */.$o)({
            key: localstorage/* LocalStorageEnum.AuthToken */.m.AuthToken
        });
        return authToken || "";
    }
    return "";
};
/**
 * @deprecated use getJwtPayload instead
 */ var getAuthTokenPayload = function(token) {
    try {
        var authToken = token || getAuthToken();
        if (!authToken) return {};
        return jwtDecode(authToken);
    } catch (error) {
        saveAuthToken({
            authToken: ""
        });
        return {};
    }
};
/**
 * @deprecated
 */ var isAuthTokenValid = function() {
    var exp = getAuthTokenPayload().exp;
    if (!exp) return false;
    return exp > new Date().getTime() / 1000;
};
/**
 * @deprecated
 */ var getAuthTokenNickname = function() {
    return null;
};
/**
 * @deprecated
 */ var getAuthTokenUserId = function() {
    return null;
};
/**
 * @deprecated
 */ var removeAuthToken = function() {
    setLocalStorage({
        key: LocalStorageEnum.AuthToken,
        value: ""
    });
};
var authTokenInitState = function() {
    return {
        token: getAuthToken(),
        userId: getAuthTokenUserId() || ""
    };
};
/**
 * @deprecated 대신에 useAuthTokenStore 사용
 */ var useAuthToken = function() {
    var ref = _sliced_to_array(React.useState(authTokenInitState), 2), ref1 = ref[0], token = ref1.token, userId = ref1.userId, setToken = ref[1];
    React.useEffect(function() {
        if (token !== getAuthToken() || userId !== getAuthTokenUserId()) {
            setToken({
                token: getAuthToken(),
                userId: getAuthTokenUserId()
            });
        }
    }, [
        token,
        userId
    ]);
    return {
        token: token,
        userId: userId
    };
};

// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/service/auth/store.ts + 1 modules
var store = __webpack_require__(3069);
// EXTERNAL MODULE: ./src/utils/toast/index.ts
var toast = __webpack_require__(1157);
;// CONCATENATED MODULE: ./src/apollo-client/error-handler-link.ts





// 인증관련 에러 상태 코드
var forbiddenError = 403;
var authCodes = [
    401,
    forbiddenError
];
// 에러 메시지 토스트 팝업은 여기서 핸들링
function getErrorHandlerLink() {
    return (0,error/* onError */.q)(function(param) {
        var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
        var ref, ref1;
        var responseStatusCode = (ref = networkError) === null || ref === void 0 ? void 0 : ref.statusCode;
        var isNetworkError = typeof responseStatusCode === "number" && responseStatusCode !== 200;
        var graphQLStatusCode = (ref1 = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code;
        var isAuthError = authCodes.includes(graphQLStatusCode) || authCodes.includes(responseStatusCode);
        // 인증 에러는 네트워크와 graphQL 응답코드 둘다 체크
        if (isAuthError) {
            var message = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0].message;
            (0,toast/* errorToast */.Jc)(graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0].message, {
                toastId: message
            });
            // 403 일때만 토큰제거 후 로그인 페이지로
            var savedToken = getAuthToken();
            if (savedToken && (forbiddenError === graphQLStatusCode || forbiddenError === responseStatusCode)) {
                (0,store/* setAuthToken */.uB)("");
                router_default().push("/sign-in");
            }
        } else if (updatePortfolioFromPlaidErrorHandler(graphQLErrors)) {
            (0,toast/* errorToast */.Jc)(graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0].message);
            return; // 컴포넌트 내부에서 자체적으로 핸들링
        } else if (isNetworkError) {
            (0,toast/* errorToast */.Jc)(networkError.message);
        } else {
            (0,toast/* errorToast */.Jc)(graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0].message);
        }
    });
};
function updatePortfolioFromPlaidErrorHandler(graphQLErrors) {
    var ref, ref1;
    return !!graphQLErrors && (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.find(function(error) {
        var ref;
        return (ref = error.path) === null || ref === void 0 ? void 0 : ref.find(function(path) {
            return path === "updatePortfolioFromPlaid";
        });
    })) || (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : (ref = graphQLErrors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.extensions) === null || ref1 === void 0 ? void 0 : ref1.code) === 400;
}

;// CONCATENATED MODULE: ./src/apollo-client/http-link.ts







var middleware = new ApolloLink/* ApolloLink */.i(function(operation, forward) {
    operation.setContext(function(param) {
        var _headers = param.headers, headers = _headers === void 0 ? {} : _headers;
        var ref;
        var language = (ref = (0,context/* getI18n */.nI)()) === null || ref === void 0 ? void 0 : ref.language;
        return {
            headers: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
                authorization: "bearer ".concat(getAuthToken())
            }), language ? {
                "accept-language": language
            } : {})
        };
    });
    return forward(operation);
});
function getHttpLink(uri) {
    return createUploadLink_default()({
        uri: uri
    });
}
function getLink(param) {
    var uri = param.uri;
    return (0,from/* from */.D)([
        middleware,
        getErrorHandlerLink(),
        getHttpLink(uri)
    ]);
};

;// CONCATENATED MODULE: ./src/apollo-client/api-server-link.ts

function apiServerLink() {
    return getLink({
        uri: "https://dev-api.therich.dev/graphql"
    });
};

;// CONCATENATED MODULE: ./src/apollo-client/api-server-apollo-client.ts





function createApiServerApolloClient(param) {
    var isServer = param.isServer;
    console.log("createApiServerApolloClient", {
        isServer: isServer
    });
    var client = new ApolloClient/* ApolloClient */.f({
        ssrMode: isServer,
        link: apiServerLink(),
        cache: apiServerApolloClientCache(),
        connectToDevTools: false
    });
    return client;
}
var apiServerApolloClient = isomorphicApolloClient(createApiServerApolloClient);
function useApiServerApolloClient() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var apolloClient = react.useMemo(function() {
        return apiServerApolloClient(initialState);
    }, [
        initialState
    ]);
    return apolloClient;
}
/* harmony default export */ var api_server_apollo_client = ((/* unused pure expression or super */ null && (apiServerApolloClient)));

;// CONCATENATED MODULE: ./src/apollo-client/index.ts



;// CONCATENATED MODULE: ./src/apollo-client/apollo-provider.tsx



function ApolloClientProvider(param) {
    var children = param.children, initialApolloState = param.initialApolloState;
    var apiServerApolloClient = useApiServerApolloClient(initialApolloState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider/* ApolloProvider */.e, {
        client: apiServerApolloClient,
        children: children
    });
};


/***/ }),

/***/ 6446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LocalStorageEnum; }
/* harmony export */ });
/* unused harmony export getChattingNoticeKey */
var LocalStorageEnum;
(function(LocalStorageEnum) {
    LocalStorageEnum["AuthToken"] = "AUTH_TOKEN";
    LocalStorageEnum["FundoraAuthToken"] = "FUNDORA_AUTH_TOKEN";
    LocalStorageEnum["RecentStocks"] = "THERICH_RECENT_STOCKS_2";
    LocalStorageEnum["Locale"] = "THERICH_LOCALE";
    LocalStorageEnum["LoginPlatform"] = "THERICH_LOGIN_PLATFORM";
    LocalStorageEnum["CommunityRecentSearches"] = "THERICH_COMMUNITY_RECENT_SEARCHES";
    LocalStorageEnum["CommunityTimelineInfluencer"] = "THERICH_COMMUNITY_TIMELINE_INFLUENCER";
    LocalStorageEnum["metaPortfolioLock"] = "THERICH_META_PORTFOLIO_LOCK";
    LocalStorageEnum["NewsCountry"] = "THERICH_NEWS_COUNTRY";
    LocalStorageEnum["DividendCountry"] = "THERICH_DIVIDEND_COUNTRY";
    LocalStorageEnum["OnBoardingIntro"] = "ON_BOARDING_INTRO";
    LocalStorageEnum["InvisibleAds"] = "THERICH_INVISIBLE_ADS";
    LocalStorageEnum["NewsRecentSearches"] = "THERICH_NEWS_RECENT_SEARCHES";
    LocalStorageEnum["FavoriteAssetsReorder"] = "THERICH_FAVORITE_ASSETS_REORDER";
    LocalStorageEnum["LoanInterestCalculatorValues"] = "LOAN_INTEREST_CALCULATOR_VALUES";
    LocalStorageEnum["ProfessionalInvestorApplicationOptionValues"] = "PROFESSIONAL_INVESTOR_APPLICATION_OPTION_VALUES";
    LocalStorageEnum["LastFocusedVideoId"] = "LAST_FOCUSED_VIDEO_ID";
})(LocalStorageEnum || (LocalStorageEnum = {}));
var getChattingNoticeKey = function(param) {
    var chatId = param.chatId;
    return "THERICH_CHAT_NOTICE_".concat(chatId);
};


/***/ }),

/***/ 3069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uB": function() { return /* binding */ setAuthToken; },
  "wX": function() { return /* binding */ useAuthTokenStore; }
});

// UNUSED EXPORTS: authTokenStore, getAuthToken, getJwtPayload, getUserIdByToken

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(6438);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useReactiveVar.js
var useReactiveVar = __webpack_require__(3433);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/utils/jwt/is-expired.ts

function isExpired(token) {
    var correction = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).correction;
    try {
        var exp = (0,jwt_decode_esm/* default */.Z)(token).exp;
        return !exp || exp * 1000 - (correction !== null && correction !== void 0 ? correction : 0) < new Date().getTime();
    } catch (error) {
        return true;
    }
};

// EXTERNAL MODULE: ./src/utils/browser/localstorage.ts
var localstorage = __webpack_require__(9454);
// EXTERNAL MODULE: ./src/constants/localstorage.ts
var constants_localstorage = __webpack_require__(6446);
;// CONCATENATED MODULE: ./src/service/auth/store.ts






var authTokenStore = (0,reactiveVars/* makeVar */.QS)({
    token: "",
    userId: ""
});
var getJwtPayload = function(token) {
    return token && !isExpired(token) ? (0,jwt_decode_esm/* default */.Z)(token) : null;
};
var getUserIdByToken = function(token) {
    var ref;
    var jwtPayload = getJwtPayload(token);
    return jwtPayload && ((ref = jwtPayload.data) === null || ref === void 0 ? void 0 : ref.user_id) ? "".concat(jwtPayload.data.user_id) : "";
};
var setAuthTokenStore = function(token) {
    authTokenStore({
        token: token,
        userId: getUserIdByToken(token)
    });
};
var getAuthToken = function() {
    return (0,localstorage/* getLocalStorage */.$o)({
        key: constants_localstorage/* LocalStorageEnum.AuthToken */.m.AuthToken
    });
};
var useAuthTokenStore = function() {
    var ref = (0,useReactiveVar/* useReactiveVar */.l)(authTokenStore), token = ref.token, userId = ref.userId;
    react.useEffect(function() {
        if (!token) {
            setAuthTokenStore(getAuthToken());
        }
    }, [
        token
    ]);
    return {
        token: token,
        userId: userId
    };
};
var setAuthToken = function() {
    var newToken = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    (0,localstorage/* setLocalStorage */.qQ)({
        key: constants_localstorage/* LocalStorageEnum.AuthToken */.m.AuthToken,
        value: newToken
    });
    setAuthTokenStore(newToken !== null && newToken !== void 0 ? newToken : "");
};


/***/ }),

/***/ 9454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ getLocalStorage; },
/* harmony export */   "qQ": function() { return /* binding */ setLocalStorage; }
/* harmony export */ });
/* unused harmony export removeLocalStorage */
// 로컬스토리지 json parse로 가져올때 에러나는 경우 대응할 수 있는 안전한 함수
var getLocalStorage = function(param) {
    var key = param.key, _type = param.type, type = _type === void 0 ? "string" : _type, fallbackValue = param.fallbackValue;
    if (!(__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.localStorage)) return fallbackValue || "";
    // 로컬스토리지는 저장 반환 only string 타입
    var dataStr = localStorage.getItem(key);
    try {
        if (dataStr) {
            if (type === "string" && typeof dataStr === "string") {
                return /".*"/.test(dataStr) ? "".concat(JSON.parse(dataStr)) : dataStr;
            }
            var data = JSON.parse(dataStr);
            if (type === "number" && typeof data === "number" || type === "boolean" && typeof data === "boolean" || type === "array" && Array.isArray(data) || type === "object" && typeof data === "object") {
                return data;
            } else if (fallbackValue) {
                return fallbackValue;
            }
            return data;
        }
    } catch (error) {
        return fallbackValue || "";
    }
    return fallbackValue || "";
};
var setLocalStorage = function(param) {
    var key = param.key, value = param.value;
    if (!(__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.localStorage)) return;
    localStorage.setItem(key, JSON.stringify(value));
};
var removeLocalStorage = function(param) {
    var key = param.key;
    if (!(__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.localStorage)) return;
    localStorage.removeItem(key);
};


/***/ }),

/***/ 1157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jc": function() { return /* binding */ errorToast; },
/* harmony export */   "iL": function() { return /* binding */ defaultToast; }
/* harmony export */ });
/* unused harmony exports successToast, infoToast, warnToast */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2920);


var commonOptions = function(text, options) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        autoClose: 1200,
        closeButton: false,
        hideProgressBar: true,
        position: "bottom-center"
    }, options);
};
var successToast = function(text, options) {
    return toast.success(text, commonOptions(text, options));
};
var defaultToast = function(text, options) {
    return (0,react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am)(text, commonOptions(text, options));
};
var infoToast = function(text, options) {
    return toast.info(text, commonOptions(text, options));
};
var errorToast = function(text, options) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast.error */ .Am.error(text, commonOptions(text, options));
};
var warnToast = function(text, options) {
    return toast.warn(text, commonOptions(text, options));
};


/***/ })

}]);